import * as Dialog from '@radix-ui/react-dialog'
import { Keyboard, X } from 'lucide-react'
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts'

export default function KeyboardShortcutsDialog() {
  const { isOpen, closeShortcuts, shortcuts } = useKeyboardShortcuts()

  function handleOpenChange(open: boolean) {
    if (!open) {
      closeShortcuts()
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-50 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
        <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md bg-card border border-border rounded-lg shadow-lg data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-border">
            <div className="flex items-center gap-2">
              <Keyboard className="w-5 h-5 text-primary" />
              <Dialog.Title className="text-lg font-semibold">
                Keyboard Shortcuts
              </Dialog.Title>
            </div>
            <Dialog.Close asChild>
              <button
                className="p-1.5 rounded-lg hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground"
                aria-label="Close"
              >
                <X className="w-4 h-4" />
              </button>
            </Dialog.Close>
          </div>

          {/* Body */}
          <div className="px-6 py-4 space-y-0">
            {shortcuts.map((group, groupIndex) => (
              <div key={group.title}>
                {groupIndex > 0 && (
                  <div className="border-t border-border my-3" />
                )}
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">
                  {group.title}
                </p>
                <div className="space-y-0">
                  {group.shortcuts.map((shortcut) => (
                    <div
                      key={shortcut.description}
                      className="flex items-center justify-between py-1.5"
                    >
                      <span className="text-sm">{shortcut.description}</span>
                      <div className="flex items-center gap-1">
                        {shortcut.keys.map((key, i) => (
                          <span key={i}>
                            {i > 0 && (
                              <span className="text-muted-foreground text-xs mx-0.5">+</span>
                            )}
                            <kbd className="inline-flex items-center px-1.5 py-0.5 text-xs font-mono bg-secondary border border-border rounded">
                              {key}
                            </kbd>
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
